const TRANSLATIONS_EN = {
    connectionError: 'Connection error. Click to retry.',
    saveFailed: 'Save failed. Click to retry.'
};

export default TRANSLATIONS_EN;
